
// const accordionHeaders = document.querySelectorAll('.footer__block--content');
//
// for (const accordionHeader of accordionHeaders) {
//   const footerCollapse = accordionHeader.querySelector('.footer__block--collapse');
//   const footerCollapseHeight = footerCollapse.clientHeight;
//   footerCollapse.setAttribute('data-max-height', footerCollapseHeight);
//   if (window.innerWidth < 768) {
//     footerCollapse.style.height = 0;
//   }
//
//
//   accordionHeader.addEventListener('click', function() {
//     accordionHeader.classList.toggle('active');
//     //set height of footer__quicklinks element to 0 if it's not has the class active
//     if(!accordionHeader.classList.contains('active')) {
//       footerCollapse.style.height = 0;
//     } else {
//       const height = footerCollapse.getAttribute('data-max-height') * 1.0;
//       //set height of footer__quicklinks element to the value of data-max-height attribute
//       footerCollapse.style.height = (height + 10 )+ 'px';
//     }
//   });
//
// }
document.addEventListener('DOMContentLoaded', function() {
    var checkoutButton = document.querySelector('.cart__checkout');
    
    if (checkoutButton) {
        checkoutButton.addEventListener('click', function() {
            localStorage.setItem('fromCheckout', 'true');
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    // Check if the user came from the checkout page
    if (localStorage.getItem('fromCheckout') === 'true') {
        // Remove the flag
        localStorage.removeItem('fromCheckout');
        // Reload the page
        window.location.reload();
    }
});
